import { create } from 'zustand';

export interface IShopifyStore {
  isShowBanner?: boolean;
  setIsShowBanner: (isShowBanner: boolean) => void;
}

export const useAppConfigStore = create<IShopifyStore>()((set, get) => ({
  isShowBanner: undefined,
  setIsShowBanner: (isShowBanner) => set({ isShowBanner }),
}));
